

import { optionsArea } from "./ChartOptionsArea";
import { getBarColorsByCompany, optionsBar } from "./ChartOptionsBar";
import { getDonutColorsByCompany, optionsDonut } from "./ChartOptionsDonut";
import { optionsLine } from "./ChartOptionsLine";

export const optionsChartDonut = optionsDonut;
export { getDonutColorsByCompany, getBarColorsByCompany };
export const optionsChartArea =  optionsArea;
export const optionsChartLine =  optionsLine;
export const optionsChartBar =  optionsBar;